import { render, staticRenderFns } from "./AsideLeft.vue?vue&type=template&id=5ff5baa2"
import script from "./AsideLeft.vue?vue&type=script&lang=js"
export * from "./AsideLeft.vue?vue&type=script&lang=js"
import style0 from "./AsideLeft.vue?vue&type=style&index=0&id=5ff5baa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports